import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

/**
 * Lets a page inject a subtitle / action buttons into the global topbar page
 * header without the Layout having to know about every route.
 */
function Slot({ id, children }) {
  const [node, setNode] = useState(null);
  useEffect(() => {
    setNode(document.getElementById(id));
  }, [id]);
  if (!node) return null;
  return createPortal(children, node);
}

export const PageSubtitle = ({ children }) => (
  <Slot id="page-subtitle-slot">
    <span className="text-sm text-muted-foreground">{children}</span>
  </Slot>
);

export const PageActions = ({ children }) => (
  <Slot id="page-actions-slot">
    <div className="flex flex-wrap items-center gap-2 w-full sm:w-auto [&>*]:grow sm:[&>*]:grow-0">{children}</div>
  </Slot>
);
